/**
 * Labstep
 *
 * @module components/EntityUserRole/Form/fields
 * @desc Form Fields for EntityUserRole
 */

import type { OptionsGroup } from 'labstep-web/components/EntityUserRole/SelectPanel/types';

export const ENTITY_USER_ROLE_OPTIONS_GROUPS: OptionsGroup[] = [
  {
    label: 'System',
    options: [
      {
        value: 'creator',
        label: 'Creator',
        icon: 'user circle',
        description: 'The user who created the Experiment',
      },
      {
        value: 'contributor',
        label: 'Contributor',
        icon: 'group',
        description: 'Anyone who has made changes to the Experiment',
      },
    ],
  },
];
